// extracted by mini-css-extract-plugin
export default {"backToHome":"NotFound_backToHome__LbRC0"};